import type { SVGProps } from "react";

export default function SearchIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M9.58341 17.6771C13.9557 17.6771 17.5001 14.1327 17.5001 9.76042C17.5001 5.38816 13.9557 1.84375 9.58341 1.84375C5.21116 1.84375 1.66675 5.38816 1.66675 9.76042C1.66675 14.1327 5.21116 17.6771 9.58341 17.6771Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M15.4167 15.5933L18.3334 18.5099"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
